import {} from 'react';

const WarningIcon = () => (
  <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.886483 15.493C0.494345 16.1596 0.975001 17 1.74842 17H18.2516C19.025 17 19.5057 16.1596 19.1135 15.493L10.8619 1.46529C10.4753 0.807982 9.52472 0.807981 9.13807 1.46529L0.886483 15.493ZM10.9091 13.4211C10.9091 13.9152 10.5085 14.3158 10.0144 14.3158H9.98565C9.4915 14.3158 9.09091 13.9152 9.09091 13.4211C9.09091 12.9269 9.4915 12.5263 9.98565 12.5263H10.0144C10.5085 12.5263 10.9091 12.9269 10.9091 13.4211ZM10.9091 9.82775C10.9091 10.3298 10.5021 10.7368 10 10.7368C9.49792 10.7368 9.09091 10.3298 9.09091 9.82775V8.06699C9.09091 7.56491 9.49792 7.15789 10 7.15789C10.5021 7.15789 10.9091 7.56491 10.9091 8.06699V9.82775Z"
      fill="#FF7B7A"
    />
  </svg>
);

export default WarningIcon;
